/* eslint-disable */
export default {
  dialer: 'Tastiera del telefono',
  allCalls: 'Tutte le chiamate',
} as const;

// @key: @#@"dialer"@#@ @source: @#@"Dial Pad"@#@
// @key: @#@"allCalls"@#@ @source: @#@"All Calls"@#@
